export const check = (data: unknown): boolean => {
    return data !== "" && data !== false && data !== null && data !== undefined;
};
